import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { createProductCategory } from "api/thunk/productCategories/postActions/createProductCategory";
import { updateProductCategory } from "api/thunk/productCategories/putActions/updateProductCategory";
import { getProductCategoryByCategoryId } from "api/thunk/productCategories/getActions/getProductCategoryByCategoryId";
import { getProductsCategories } from "api/thunk/productCategories/getActions/getProductsCategories";
import { deleteProductCategoryByCategoryId } from "api/thunk/productCategories/deleteActions/deleteProductCategoryByCategoryId";
import { getProductsCategoriesForInfinitySelect } from "api/thunk/productCategories/getActions/getProductsCategoriesForInfinitySelect";

const productCategoriesSlice = createSlice({
  name: "product categories",
  initialState,
  reducers: {
    setProductsCategoriesPage: (state, action: PayloadAction<number>) => {
      state.productsCategories.params.page = action.payload;
    },
    setProductsCategoriesPageSize: (state, action: PayloadAction<number>) => {
      state.productsCategories.params.pageSize = action.payload;
      state.productsCategories.params.page = 1;
    },
    setProductsCategoriesHasMore: (state, action) => {
      state.productsCategoriesForInfinitySelect.params.hasMore = action.payload;
    },
    setProductsCategoriesSearchTerm: (state, action) => {
      state.productsCategoriesForInfinitySelect.params.searchTerm = action.payload;
    },
    setAllProductsCategories: (state, action) => {
      state.productsCategoriesForInfinitySelect.response.data = action.payload ?? [];
    },
    setProductCategoryId: (state, action) => {
      state.productCategoryId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //create_product_categories
      .addCase(createProductCategory.pending, (state) => {
        state.productCategory.response.loading = true;
        state.productCategory.response.error = null;
      })
      .addCase(createProductCategory.fulfilled, (state, action) => {
        state.productCategory.response.loading = false;
        state.productCategory.response.data = action.payload;
      })
      .addCase(createProductCategory.rejected, (state, action) => {
        state.productCategory.response.loading = false;
        state.productCategory.response.error =
          action.error.message || "Неизвестная ошибка";
        state.productCategory.response.data = null;
      })
      //update_product_categories
      .addCase(updateProductCategory.pending, (state) => {
        state.updateProductCategory.loading = true;
        state.updateProductCategory.error = null;
      })
      .addCase(updateProductCategory.fulfilled, (state, action) => {
        state.updateProductCategory.loading = false;
        state.updateProductCategory.data = action.payload;
      })
      .addCase(updateProductCategory.rejected, (state, action) => {
        state.updateProductCategory.loading = false;
        state.updateProductCategory.error =
          action.error.message || "Неизвестная ошибка";
        state.updateProductCategory.data = null;
      })
      //get_product_category_by_category_id
      .addCase(getProductCategoryByCategoryId.pending, (state) => {
        state.productCategoryById.response.loading = true;
        state.productCategoryById.response.error = null;
      })
      .addCase(getProductCategoryByCategoryId.fulfilled, (state, action) => {
        state.productCategoryById.response.loading = false;
        state.productCategoryById.response.data = action.payload;
      })
      .addCase(getProductCategoryByCategoryId.rejected, (state, action) => {
        state.productCategoryById.response.loading = false;
        state.productCategoryById.response.error =
          action.error.message || "Неизвестная ошибка";
        state.productCategoryById.response.data = null;
      })
      //get_products_categories
      .addCase(getProductsCategories.pending, (state) => {
        state.productsCategories.response.loading = true;
        state.productsCategories.response.error = null;
      })
      .addCase(getProductsCategories.fulfilled, (state, action) => {
        state.productsCategories.response.loading = false;
        state.productsCategories.response.data = action.payload;
      })
      .addCase(getProductsCategories.rejected, (state, action) => {
        state.productsCategories.response.loading = false;
        state.productsCategories.response.error =
          action.error.message || "Неизвестная ошибка";
        state.productsCategories.response.data = null;
      })

      //get_products_categories_for_infinity_select
      .addCase(getProductsCategoriesForInfinitySelect.pending, (state) => {
        state.productsCategoriesForInfinitySelect.response.loading = true;
        state.productsCategoriesForInfinitySelect.response.error = null;
      })
      .addCase(getProductsCategoriesForInfinitySelect.fulfilled, (state, action) => {
        state.productsCategoriesForInfinitySelect.response.loading = false;
        state.productsCategoriesForInfinitySelect.response.data = action.payload;
      })
      .addCase(getProductsCategoriesForInfinitySelect.rejected, (state, action) => {
        state.productsCategoriesForInfinitySelect.response.loading = false;
        state.productsCategoriesForInfinitySelect.response.error =
          action.error.message || "Неизвестная ошибка";
        state.productsCategoriesForInfinitySelect.response.data = null;
      })
      //delete_product_category_by_category_id
      .addCase(deleteProductCategoryByCategoryId.pending, (state) => {
        state.deleteProductCategory.loading = true;
        state.deleteProductCategory.error = null;
      })
      .addCase(deleteProductCategoryByCategoryId.fulfilled, (state, action) => {
        state.deleteProductCategory.loading = false;
        state.deleteProductCategory.data = action.payload;
      })
      .addCase(deleteProductCategoryByCategoryId.rejected, (state, action) => {
        state.deleteProductCategory.loading = false;
        state.deleteProductCategory.error =
          action.error.message || "Неизвестная ошибка";
        state.deleteProductCategory.data = null;
      })
  },
});

export const {
  setProductsCategoriesPage,
  setProductsCategoriesPageSize,
  setProductsCategoriesSearchTerm,
  setProductsCategoriesHasMore,
  setAllProductsCategories,
  setProductCategoryId
} = productCategoriesSlice.actions;

export default productCategoriesSlice.reducer;
